import React, { useState } from 'react';
import './CustomGpt.css';

const CustomGpt = () => {
  const [activeTab, setActiveTab] = useState('Company GPT');

  // Content for each tab
  const tabContent = {
    'Company GPT': {
      description: 'Revolutionize your internal operations with a company-exclusive AI. Empower your team with seamless knowledge retrieval, tailored insights, and intelligent decision-making.',
      imageSrc:  '/image/custom_gpt.webp',
    },
    'Chat Bots': {
      description: 'Design bots that align perfectly with your business needs. From tailored workflows to personalized interactions, our custom bots redefine automation and customer engagement.',
      imageSrc:   '/image/custom_bot.webp',
    },
    'Customer Care': {
      description: 'Deliver exceptional customer experiences with AI-driven care solutions. Automate responses, resolve issues instantly, and elevate satisfaction levels.',
      imageSrc: '/image/customer_care.webp',
    },
    'Data Analytics ': {
      description: 'Unlock the power of your data with advanced AI analytics. Gain actionable insights, predict trends, and drive informed decisions with ease.',
      imageSrc:  '/image/data_analysis.webp',
    },
    'Automation': {
      description: 'Streamline your workflows and eliminate repetitive tasks. Automate processes with precision, saving time and resources while boosting productivity.',
      imageSrc:  '/image/task_automation.webp',
    },
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="custom-gpt-card">
      <div className="custom-gpt-card-section">
        <div className="custom-gpt-image-content">
          {tabContent[activeTab].imageSrc && (
            <img src={tabContent[activeTab].imageSrc} alt={`${activeTab} Example`} className="custom-gpt-image" />
          )}
          {tabContent[activeTab].codeSnippet && (
            <div className="custom-gpt-code-snippet">
              <pre>
                <code>{tabContent[activeTab].codeSnippet}</code>
              </pre>
            </div>
          )}
        </div>
        <div className="custom-gpt-text-content">
          <h2 className="custom-gpt-section-title">Custom GPTS </h2>
          <p className="custom-gpt-section-subtitle">Build and deploy your very own custom company-level ChatGPT</p>
          <div className="custom-gpt-tags">
            {Object.keys(tabContent).map((tab) => (
              <span
                key={tab}
                className={`custom-gpt-tag ${activeTab === tab ? 'active' : ''}`}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </span>
            ))}
          </div>
          <p className="custom-gpt-section-description">{tabContent[activeTab].description}</p>
          <button className="custom-gpt-action-button">Contact Us &rarr;</button>
        </div>
      </div>
    </div>
  );
};

export default CustomGpt;
